import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

import Loading from '../blocks/loading/Loading';
import Header from '../blocks/header/Header';
import Footer from '../blocks/footer/Footer';

import WorkInside from '../blocks/workinside/WorkInside';

const WorksInside = () => {
  const param = useParams();
  document.body.classList.add('single');
  document.body.classList.add('single-portfolio');
  document.body.classList.add('bg-fixed');
  document.body.classList.add('bg-line');
  return (
    <Fragment>
      <MetaTags>
        <meta charSet="UTF-8" />
        <title>Works Inside | Chinese New Year editorial site</title>

        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </MetaTags>

      <Loading />

      <Header />

      <main id="main" className="site-main bg-half-ring-right bg-half-ring-top">
        <WorkInside workId={param.workId} />
      </main>

      <Footer />
    </Fragment>
  );
};

export default WorksInside;
